import React from 'react'
import { ContainerBox, ImageBox } from './banner.style'
import { observer } from '~/common/mobx.decorator'
import { appStore } from '~/stores'
import { ANO_BANNER_URLS, DEFAULT_ANO_BANNER } from '../layout/image-urls'

export const Banner = observer(({ bannerUrl, ...props }) => {
	const AnoBannerUrl = ANO_BANNER_URLS[appStore.jobBoardCode] || DEFAULT_ANO_BANNER

	return (
		<>
			<ContainerBox {...props}>
				<ImageBox url={AnoBannerUrl}></ImageBox>
			</ContainerBox>
		</>
	)
})
